import React from "react";
import {
  Avatar,
  Container,
  Typography,
} from "@material-ui/core";

const testimonials = [
  {
    name: "alex Janson",
    role: "Designer",
  },
  {
    name: "Sarah mendes",
    role: "Designer",
  },
  {
    name: "James Fread",
    role: "Designer",
  },
  {
    name: "Amanda Janson",
    role: "Designer",
  },
  {
    name: "AndrEew Flock",
    role: "Designer",
  },
];

const text =
  "A wonderful serenity has taken possession of entire soul, like these sweet mornings of spring which I enjoy with my whole heart.";

const Testimonials: React.FC = () => {
  return (
    <div className="testimonial-section">
      <Container maxWidth="lg">
        <div className="section-heading testimonial-heading">
          <Typography className="section-eyebrow">
            Testimonial
          </Typography>

          <Typography className="section-title">
            Our Client Say
          </Typography>
        </div>

        <div className="testimonial-grid">
          {testimonials.map((item) => (
            <div
              className="testimonial-card"
              key={item.name}
            >
              <Avatar className="testimonial-avatar">
                {item.name.charAt(0)}
              </Avatar>

              <Typography className="testimonial-name">
                {item.name}
              </Typography>

              <Typography className="testimonial-role">
                {item.role}
              </Typography>

              <Typography className="testimonial-text">
                {text}
              </Typography>
            </div>
          ))}
        </div>
      </Container>
    </div>
  );
};

export default Testimonials;